// extracted by mini-css-extract-plugin
export default {"separatorContainer":"styles_separatorContainer__FUX46","separatorLine":"styles_separatorLine__CLph2","separatorIcon":"styles_separatorIcon__-m3pX"};